
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 31 31"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.8 20.15V4.65A4.65 4.65 0 0020.15 0H4.65A4.65 4.65 0 000 4.65v15.5a4.65 4.65 0 004.65 4.65h15.5a4.65 4.65 0 004.65-4.65zM3.1 4.65A1.55 1.55 0 014.65 3.1h15.5a1.55 1.55 0 011.55 1.55v6.758l-1.674-1.69a3.968 3.968 0 00-2.805-1.162 3.999 3.999 0 00-2.806 1.163l-1.41 1.41-1.256-1.255a4.542 4.542 0 00-6.37 0L3.1 12.166V4.65zm.186 16.197a1.457 1.457 0 01-.186-.697v-3.611l4.464-4.465a1.41 1.41 0 012 0l1.286 1.256-7.564 7.518zm13.33-8.928a.805.805 0 01.605-.263.806.806 0 01.604.263l3.875 3.86v4.371a1.55 1.55 0 01-1.55 1.55H6.82l9.796-9.78zM29.45 6.2a1.55 1.55 0 00-1.55 1.55v15.5a4.65 4.65 0 01-4.65 4.65H7.75a1.55 1.55 0 100 3.1h15.5A7.75 7.75 0 0031 23.25V7.75a1.55 1.55 0 00-1.55-1.55z"}})])
          )
        }
      }
    